var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnLikeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91252 14.3936C6.29235 13.4211 4.78514 12.2766 3.41784 10.9805C2.45658 10.0471 1.72477 8.90923 1.27848 7.65398C0.47538 5.21895 1.41346 2.43131 4.03873 1.60632C5.41847 1.17314 6.92535 2.14867 8.08799 2.99958C9.25108 2.1497 10.7574 1.17426 12.1373 1.60632C14.7625 2.43131 15.7074 5.21895 14.9042 7.65398C14.458 8.90923 13.7262 10.0471 12.7649 10.9805C11.3976 12.2766 9.89038 13.4211 8.27021 14.3936L8.09474 14.5L7.91252 14.3936Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLikeOutline);
export default __webpack_public_path__ + "static/media/icn-like-outline.415de20c22daffa3ffe25697badfb866.svg";
export { ForwardRef as ReactComponent };